<template>
  <div>
    <h2 class="t-c" v-if="!showTable">Não há fixação de preços para este contrato</h2>

    <table v-if="$appUtils.isDesktop() && showTable"
           class="table table-hover table-striped table-sm table-bordered">
      <thead class="thead-dark thead-center">
      <tr>
        <th style="width: 120px">PREÇO</th>
        <th style="width: 120px">QUANTIDADE</th>
        <th style="width: 120px">DATA</th>
        <th>OBSERVAÇÕES</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(pfa, idx) in entity.proposal_fixings_attributes" :key="idx" class="line-item">
        <td class="v-m c-p t-r" @click="showModal(pfa)">{{ pfa.price | formatMoney }}</td>
        <td class="v-m c-p t-r" @click="showModal(pfa)">{{ pfa.quantity | formatNumber(3, ',', '.') }}</td>
        <td class="v-m c-p t-c" @click="showModal(pfa)">{{ pfa.fixing_at | formatDate }}</td>
        <td class="v-m c-p p-r o-h" @click="showModal(pfa)">
          {{ pfa.notes }}
          <div class="actions btn-group btn-group-xs">
            <button type="button"
                    class="btn btn-danger btn-xs"
                    @click.stop="() => destroy(idx)"
                    title="Remover">
              <svg-icon icon="trash-alt"/>
            </button>
            <button type="button"
                    class="btn btn-secondary btn-xs"
                    @click.stop="$emit('onSendByEmail', {id: pfa.id, type: 'fixing'})"
                    title="Enviar por e-mail">
              <svg-icon icon="envelope"/>
            </button>
          </div>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <th rowspan="2"></th>
        <th class="v-m t-r f-w-700">{{ totalQuantity | formatNumber(3, ',', '.') }}</th>
        <th class="v-m f-w-700" colspan="2">Quantidade total fixado</th>
      </tr>
      <tr>
        <th class="v-m t-r f-w-700">{{ entity.quantity | formatNumber(3, ',', '.') }}</th>
        <th class="v-m f-w-700" colspan="2">Quantidade contrato</th>
      </tr>
      </tfoot>
    </table>
    <div class="t-r" v-if="!!entity.id">
      <button type="button"
              class="btn btn-sm btn-outline-primary"
              @click="showModal">
        <svg-icon icon="plus"/> Adicionar Fixação
      </button>
    </div>

    <ModalFixingQuantity @onSave="onSave"/>
  </div>
</template>

<script>
import ModalFixingQuantity, {show} from "@/views/proposals/ModalFixingQuantity";
import {mapMutations, createNamespacedHelpers} from 'vuex'
import Big from "big.js";
const {mapActions} = createNamespacedHelpers('proposals');
export default {
  name: "FixingArea",
  components: {ModalFixingQuantity},
  props: {
    entity: {
      type: Object,
      required: true,
      default: {}
    }
  },

  methods: {
    ...mapMutations(['addModal', 'destroyModal']),
    ...mapActions(['destroyFixing']),
    showModal(pfa) {
      if (this.entity.price_type === 'value_defined') {
        this.$snotify.error('Só é possível adicionar fixação para contratos com preço "A Fixar"', this.$appStorage.getUser().name);
        return
      }

      let fixing_quantity;
      if (!!pfa) {
        fixing_quantity = {
          ...pfa,
          quantity: this.$appUtils.formatNumber(pfa.quantity, 3, ',', '.'),
          price: this.$appUtils.formatMoney(pfa.price, 2, ',', '.'),
          fixing_at: this.$appUtils.formatDate(pfa.fixing_at),
        }
      } else fixing_quantity = {
        price: 0,
        quantity: 0,
        fixing_at: ''
      }
      show(fixing_quantity)
    },
    onSave(pfa) {
      const attr = 'proposal_fixings_attributes'
      if (!this.$appUtils.isArray(this.entity[attr])) this.$set(this.entity, attr, []);

      const newEntity = {
        proposal_id: this.entity.id,
        ...pfa
      }

      if (!newEntity.id) newEntity._id = Math.random()

      let newArr = [...this.entity[attr]]

      if (newArr.indexById(newEntity) >= -1) newArr.pushOrChange(newEntity)
      else newArr = [newEntity, ...newArr]

      this.$set(this.entity, attr, newArr)

      this.$emit('onUpdateTabs')
    },
    destroy(idx) {
      this.addModal({
        title: 'Fixação', size: 'small', body: 'Deseja remover essa fixação?', buttons: [{
          type: 'ok', class: 'btn btn-theme-1 btn-sm', method: async (id) => {
            const fixing = this.entity.proposal_fixings_attributes[idx]

            if (!!fixing._id) {
              this.entity.proposal_fixings_attributes.deleteObject(fixing)
            } else {
              await this.destroyFixing(fixing.id);
              this.$delete(this.entity.proposal_fixings_attributes, this.entity.proposal_fixings_attributes.indexById({id: fixing.id}));
              this.$snotify.success(this.$t('common.destroyItemSuccess'), this.$appStorage.getUser().name);

              this.$emit('onUpdateTabs', {});
            }
            this.destroyModal(id);
            this.$emit('onUpdateTabs')
          }
          },
          {type: 'close', label: 'Não', method: this.destroyModal}
        ]
      });
    }
  },
  computed: {
    showTable() {
      return (this.entity.proposal_fixings_attributes || []).isNotEmpty()
    },
    totalQuantity() {
      if ((this.entity.proposal_fixings_attributes || []).isNotEmpty()) {
        let total = new Big('0')

        this.entity.proposal_fixings_attributes.forEach(pfa => {
          total = total.plus(new Big(pfa.quantity).toString())
        })

        return parseFloat(total.toString())
      }
    }
  }
}
</script>
